module.exports = __webpack_public_path__ + "img/lufuren.0507f500.jpg";